
import { useLocation, useNavigate } from 'react-router-dom';
import { UserProfile } from '../../types';
import { FileText, Folder, Tag, Sparkles } from 'lucide-react';

import ArticleList from './Blog/ArticleList';
import CategoryManager from './Blog/CategoryManager';
import TagManager from './Blog/TagManager';
import AIGenerator from './Blog/AIGenerator';

// FIX: Added 'categories' property to match the type definition in ArticleList.tsx and the data from the API.
interface BlogPost {
  id: number;
  title: string;
  status: string;
  author_id: number;
  created_at: number;
  categories: string | null;
}

interface BlogTabProps {
    currentUser: UserProfile;
    blogPosts: BlogPost[];
    onDataNeededRefresh: () => void;
    totalCount?: number;
    currentPage?: number;
    onPageChange?: (page: number) => void;
    titleQuery: string;
    onTitleQueryChange: (query: string) => void;
    slugQuery: string;
    onSlugQueryChange: (query: string) => void;
    selectedCategoryIds: number[];
    onSelectedCategoryIdsChange: (ids: number[]) => void;
    createdFrom: string;
    createdTo: string;
    onCreatedFromChange: (value: string) => void;
    onCreatedToChange: (value: string) => void;
}

const BlogTab: React.FC<BlogTabProps> = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const adminPath = pathSegments[0] || '';
    const basePath = `/${adminPath}/blog`;
    const subTab = pathSegments[2] || 'articles';

    const renderSubPage = () => {
        switch (subTab) {
            case 'categories': return <CategoryManager currentUser={props.currentUser} />;
            case 'tags': return <TagManager currentUser={props.currentUser} />;
            case 'generate': return <AIGenerator currentUser={props.currentUser} />;
            case 'articles':
            default:
                return <ArticleList {...props} />;
        }
    };

    const navItems = [
        { id: 'articles', label: 'Blog', icon: FileText },
        { id: 'categories', label: 'Categories', icon: Folder },
        { id: 'tags', label: 'Tags', icon: Tag },
        { id: 'generate', label: 'Generate AI', icon: Sparkles },
    ];

    return (
        <div className="w-full relative animate-fade-in">
            <div className="flex justify-between items-center mb-4 border-b border-gray-800 pb-4">
                 <h2 className="text-xl font-bold text-white flex items-center gap-2">
                    <FileText className="w-5 h-5" /> Blog Manager
                </h2>
                <nav className="flex items-center gap-2 bg-mystic-box p-1 rounded-lg border border-gray-800">
                    {navItems.map(item => (
                        <button 
                            key={item.id}
                            onClick={() => navigate(`${basePath}${item.id === 'articles' ? '' : '/' + item.id}`)}
                            className={`flex items-center gap-2 px-3 py-1.5 text-xs font-bold rounded-md transition-colors ${subTab === item.id ? 'bg-mystic-accent text-black' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`}
                        >
                            <item.icon className="w-4 h-4" />
                            {item.label}
                        </button>
                    ))}
                </nav>
            </div>
            
            <div>
                {renderSubPage()}
            </div>
        </div>
    );
};

export default BlogTab;